import React from "react";
import CommonImage from "@/components/common/image/CommonImage";
import Link from "next/link";

export default function InstructorCard({ instructor }) {
  return (
    <div className="advisor-card-wrap bg-pattern">
      <div className="advisor-card">
        <div className="advisor-image-wrap">
          <div className="advisor-image">
            <CommonImage
              src={
                instructor?.avatar_url ??
                "/images/home-page/advisor-profile.avif"
              }
              className="advisor-img leading-[0]"
              alt={"Image"}
            />
          </div>
        </div>
        <div className="advisor-data-wrap">
          <h2 className="name">{instructor?.name}</h2>
          <h3 className="title">{instructor?.designation}</h3>
          <p className="shory-des">{instructor?.short_des}</p>

          <Link
            href={`/instructors/${instructor?.slug}`}
            className="details-btn"
          >
            বিস্তারিত দেখো
            <CommonImage
              src={"/images/home-page/arrow-right-gray.svg"}
              className="img-icon"
              alt={"Image"}
            />{" "}
          </Link>
        </div>
      </div>
    </div>
  );
}
